import { MergedPatientData } from "./patientVisitData";
import { isProduction } from "fe-common/utils/envGetter";

const AGENT_CASE_API_KEY = "FTTpzynamoEAesCzfW8j3zWHiB1os8Y9QvPmbKZb";

const API_URL = isProduction()
  ? "https://api.kahun.com/cases"
  : "https://api-dev.kahun.com/cases";

export type ClinicCasePatientData = Omit<MergedPatientData, "caseUrl">;

export const createClinicPatientCase = async (
  clinicId: string,
  patientInfo: ClinicCasePatientData,
): Promise<string> => {
  const requestBody = {
    caseFormat: "athena",
    case: {
      demographics: {
        age: patientInfo.age,
        gender: patientInfo.gender,
      },
    },
    // PII data is being encrypted
    kpiiPatientProperties: {
      visit_date: patientInfo.visitDateTime,
      first_name: patientInfo.firstName,
      last_name: patientInfo.lastName,
      phone: patientInfo.phoneNumber,
      email: patientInfo.email,
    },
  };
  const response = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": AGENT_CASE_API_KEY,
      "x-kahun-clinic-id": clinicId,
    },
    body: JSON.stringify(requestBody),
  });
  const apiResult = await response.json();
  return apiResult.patient as string;
};
